exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* 简单布局微调 */\n.ivu-modal-body .ivu-form[data-v-69b9d293] {\n    padding-top: 6px;\n}\n\n/* 发票字段样式 */\n.invoiceField[data-v-69b9d293] {\n    margin-bottom: 16px;\n}\n.ivu-form-item[data-v-69b9d293] {\n    margin-bottom: 16px;\n}\n.ivu-modal-body[data-v-69b9d293] {\n    max-height: 500px;\n    overflow-y: auto;\n}\n", ""]);

// exports
